import { render } from "./SearchBlock.vue?vue&type=template&id=1a37ab50"
import script from "./SearchBlock.vue?vue&type=script&lang=js"
export * from "./SearchBlock.vue?vue&type=script&lang=js"

import "./SearchBlock.vue?vue&type=style&index=0&id=1a37ab50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__